import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { createPackageReq } from '../packageReqService'

export const useCreatePkgReq = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: createPackageReq,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PACKAGE_REQUESTS] })
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER_PACKAGES] })
    },
  })
}
